import Vue from 'vue';
import Router from 'vue-router';

import OverviewRouter from './overviewrouter';

Vue.use(Router);

export default new Router({
  routes: [
    ...OverviewRouter.routes,
  ],
});
